import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class ErrorUtils {
  static extractErrorMessage(error) {
    if (error instanceof Error) {
      return ErrorUtils.redactSensitiveInfo(error.message || 'unknown-error');
    } else {
      return ErrorUtils.redactSensitiveInfo(String(error));
    }
  }
}
_defineProperty(ErrorUtils, "redactSensitiveInfo", str => {
  const redacted = str.replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]').replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
  return redacted;
});